import styled from "styled-components";
import { Divider, Alert, Row } from "antd";
import { SectionLastHeading, ContentContainer, PillButton } from "../../../../../../CommonComponents/commonStyles";
import {
  PrimaryButtonComponent,
  GhostButtonComponent,
} from "../../../../../../CommonComponents/commonStyles";

export const ComponentDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
     margin-top: ${props => props.marginTop};
     margin-bottom: ${props => props.marginBottom};
     @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: ${props => props.mTop};
      margin-bottom: ${props => props.mBottom};
    }
}
`;

export const PillButtonComponent = styled(PillButton)`
&:hover, &:focus{
  color: #006778 !important;
  border: 1px solid #d4d4d4 !important;
  background-color: #f5f5f5 !important;
}
    margin-bottom: ${props => props.marginBottom};
    height: unset !important;
    padding: 4px 20px;
    color: #006778;
    font-size: 14px;
    background-color: #f5f5f5;
    font-family: HelveticaNeue-Medium;
`;

export const SectionHeading = styled(SectionLastHeading)`
margin-bottom: ${props => props.marginBottom};
margin-top: ${props => props.marginTop};
font-size: ${props => props.fontSize};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.mobileFont};
  margin-bottom: ${props => props.mBottom};
}
`;

export const Disclaimer = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
line-height: 1.5;
letter-spacing: 0.6px;
color: #505050;
margin-top: ${props => props.marginTop};
`;

export const Guildelines = styled.span`
text-decoration: underline;
color: #006778;
`;

export const ContribType = styled.span`
font-family: HelveticaNeue;
font-size: 16px;
color: #4a4a4a; 
`;

export const NavigationBtnContainer = styled.div`
  display:flex;
  
  & > div {
    display: flex;
    & button:nth-child(1) {
      margin-right: 1rem;
    }
  }

  @media only screen and (max-width: 991.92px) {
    flex-flow: wrap;
    & > button {
      flex-basis: 100%;
      margin-top: 0.75rem;
    }
  }
`;

export const PrimaryNavigation = styled(PrimaryButtonComponent)`
margin-right:15px;
`;

export const GhostNavigation = styled(GhostButtonComponent)`
margin-right:15px;
`;

export const NoticeContent = styled.div`
  justify-content: space-between !important;
  align-items: center;
  color: ${props => props.theme.fontColors.thead};
  flex-direction: column;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  justify-content: space-between !important;
  & > div:nth-child(1) {
    flex-basis: 75%;
    margin-bottom: ${props => props.theme.spacing.margins.webBase};
    line-height: ${props => props.theme.lineHeight.subHeading};
  }
  & > button {
    width: initial;
    align-self: flex-start;
  }

    a {
    color: ${props => props.theme.colors.primaryColor};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const NoticeBorder = styled.div`
border-left: 6px solid ${props => props.theme.colors.info};
margin-bottom: 30px;
@media only screen and (min-width: 320px) and (max-width: 767px) {
  width: unset;
}
`;

export const NoticePara = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
color: ${props => props.theme.fontColors.textColor};
`;

export const NoticeContainer = styled(Alert)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue}
  background-color: ${props => props.theme.backgroundColor.cardDark}
  border-radius: 0px;
  border: none;
  padding: 1.5rem 2rem!important;
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
    font-size: 14px;
    padding: 1rem!important;
  }
`;

export const SubmitBold = styled.div`
 font-family: ${props => props.theme.fontFamily.helveticaNeueBold}; 
 color: ${props => props.theme.fontColors.headingColor};
 font-size:  ${props => props.theme.fontSize.primary};
`;

export const EditButtonWrap = styled.div`
display: flex;
align-items: center;
`;

export const EditWrap = styled.span`
  margin-left:9px;
`;

export const ContentContainerSpace = styled(ContentContainer)`
  padding: 3.125rem 9% 0 9%;
  margin-top: ${props => (props.marginTop) ? props.marginTop : null};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: ${props => (props.mt) ? props.mt : null};
    padding: 0 0 0 6.1% ;
  }
`;

export const FlexCenter = styled(Row)`

`;

export const Content = styled.div`
    font-family: HelveticaNeue;
    font-size: 16px;
    line-height: 1.5;
    color: #505050;
    margin-bottom: ${props => props.marginBottom};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: 14px;
      margin-bottom: ${props => props.mB}
    }
`;